import type { UseAsyncDataResT } from '@dr.pogodin/react-global-state';
import { time } from '@dr.pogodin/react-utils';

import { getArtist } from 'services/artists';

import type { ArtistT } from 'utils';

import { useAsyncCollection } from 'utils/global-state';

type UseArtistOptionsT = {
  disabled?: boolean;
  withAllUserDetails?: boolean;
};

type UseArtistResT = UseAsyncDataResT<ArtistT>;

/**
 * Gets artist object for the specified ID.
 */
export function useArtist(
  id: string,
  { disabled, withAllUserDetails }: UseArtistOptionsT = {},
): UseArtistResT {
  if (typeof id !== 'string') throw Error('Internal error');

  return useAsyncCollection(
    id,
    'artists.map',
    async () => getArtist(id, { withAllUserDetails }),
    { deps: [withAllUserDetails], disabled, maxage: time.YEAR_MS },
  );
}

